import { OrganizationNormsResponse, PutOrganizationNormsRequestDto } from '@/api/generated';

import { OrganizationSettingsFieldValuesNorms } from './types';

export const serializeNorms = (
  norms?: OrganizationSettingsFieldValuesNorms
): PutOrganizationNormsRequestDto['organizationNorms'] => {
  if (!norms) return [];

  const organizationNorms: PutOrganizationNormsRequestDto['organizationNorms'] = [];

  if (norms.defaultNormId) {
    organizationNorms.push({
      default: true,
      defaultNormId: norms.defaultNormId
    });
  }

  if (norms.items) {
    norms.items.forEach(item => {
      if (item.defaultNormId) {
        organizationNorms.push({
          default: false,
          testTypeId: item.testTypeId,
          defaultNormId: item.defaultNormId
        });
      }
    });
  }

  return organizationNorms;
};

export const deserializeNorms = (
  organizationNormsData?: OrganizationNormsResponse
): OrganizationSettingsFieldValuesNorms | undefined => {
  if (!organizationNormsData?.organizationNorms) {
    return undefined;
  }

  const items: OrganizationSettingsFieldValuesNorms['items'] = [];
  let defaultNormId: string | undefined;

  organizationNormsData.organizationNorms.forEach(norm => {
    if (norm.isDefault) {
      defaultNormId = norm.defaultNorm?.id || '';
    } else if (norm.testType?.id) {
      items.push({
        defaultNormId: norm.defaultNorm?.id || '',
        testTypeId: norm.testType.id,
        testName: norm.testType.name
      });
    }
  });

  return {
    items,
    defaultNormId
  };
};
